import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Auth from './auth'
import Home from './pages/home/home'
import { ToastContainer, Bounce } from 'react-toastify'
import EditProfile from './pages/profile/editProfile'
import Profile from './pages/profile/profile'
import AddPost from './pages/studio'

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/auth' element={<Auth />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/profile/edit' element={<EditProfile />} />
          <Route path='/studio' element={<AddPost />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="bottom-left"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme="dark"
        transition={Bounce}
      />
    </>
  )
}

export default App